import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { NotificationController } from 'core-components/library/popup'
import { useProcessLogin } from 'core/layout/login/hooks'
import { selectAuthError } from 'core/store/selectors/selectAuthError'
import { RegistrationHpidSignIn } from 'onboarding/components/registration/hpidSignIn/RegistrationHpidSignIn'
import { HPLogo } from 'onboarding/components/ui/logo/HPLogo'

import styles from './APLLoginForm.module.scss'

export const APLLoginForm = () => {
  const { initiateLogin, isLoginProcessing } = useProcessLogin()
  const authError = useSelector(selectAuthError)

  // This page renders outside LayoutLogin, which is where the auth error is
  // normally surfaced, so it has to raise the notification itself.
  useEffect(() => {
    if (authError.message) {
      NotificationController.showError({ message: authError.message })
    }
  }, [authError])

  return (
    <RegistrationHpidSignIn
      onSignIn={initiateLogin}
      progress={isLoginProcessing}
      programName={'Authorized Partner List Registration'}
      logo={<HPLogo className={styles.logo} />}
      className={styles.panel}
    />
  )
}
